var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    _vm._b({}, "Card", _vm.options, false),
    _vm._l(_vm.filtersCopy, function(filter, index) {
      return _c(
        "ToggleItem",
        _vm._b(
          {
            key: index,
            attrs: { paddingY: 0.3 },
            on: {
              input: function($event) {
                var i = arguments.length,
                  argsArray = Array(i)
                while (i--) argsArray[i] = arguments[i]
                return _vm.getSelectedChilds.apply(
                  void 0,
                  [filter.name].concat(argsArray)
                )
              },
              handleClick: function($event) {
                return _vm.fireStar(filter.name)
              }
            }
          },
          "ToggleItem",
          filter,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93062696", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93062696","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/sections/GalleryFilter.vue
// module id = null
// module chunks = 